import React, { useState } from "react";
import { track } from "../../../analytics";
import "./HomeConnect.scss";
import HomeConnectCard from "./HomeConnectCard/HomeConnectCard";
import Form from "../../General/Form/Form";

/*
  Четыре шага подключения. Слайдера больше нет: шагов всегда четыре,
  на десктопе они умещаются в ряд, а на мобиле читаются таймлайном
  сверху вниз — листать нечего, да и порядок шагов важнее листания.
*/
const HomeConnect = ({ data }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="homeConnect_container">
      <div className="homeConnect_block">
        <h1>Как подключить домашний интернет Nets</h1>
        <div className="homeConnect_item">
          {data?.map((e) => (
            <HomeConnectCard
              id={e.id}
              title={e.title}
              subTitle={e.subTitle}
              key={e.id}
            />
          ))}
        </div>

        <div className="homeConnect_actions">
          <button
            type="button"
            className="homeConnect_cta"
            onClick={() => setShowModal(true)}
          >
            Оставить заявку
          </button>
          <a className="homeConnect_call" href="tel:4848" onClick={() => track("phone_click", { number: "4848" })}>
            или позвоните <span>4848</span>
          </a>
        </div>
      </div>
      {showModal && (
        <div className="form_container">
          <div className="form_block">
            <Form show={showModal} setShowModal={setShowModal} id={677} endpoint={'add_deal'} />
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeConnect;
